import { forwardRef, ForwardRefRenderFunction, HTMLAttributes } from 'react';
type Props = Omit<HTMLAttributes<HTMLDivElement>, 'className'>;
const CheckboxFieldErrorRenderFunction: ForwardRefRenderFunction<HTMLDivElement, Props> = (attrs, ref) => {
  return <div {...attrs} ref={ref} className="text-sm text-error-100" data-sentry-component="CheckboxFieldErrorRenderFunction" data-sentry-source-file="CheckboxFieldError.tsx" />;
};
export const CheckboxFieldError = forwardRef<HTMLDivElement, Props>(CheckboxFieldErrorRenderFunction);